export default __webpack_public_path__ + "static/media/SuppliersUnrelatedItemsOrangeIcon.46a11b58.png";